export const template2 = [
  {
    path: '/template2/login',
    name: 'template2_login',
    meta: {
      title: '充值查询',
      header: false,
      bottom: false,
      keepAlive: false,
      auth: false
    },
    component: () => import('@/card/views/template2/login/index')
  },
  {
    path: '/template2/login-list/:mobile',
    name: '/template2_loginList',
    meta: {
      title: '我的卡包',
      header: false,
      bottom: false,
      keepAlive: false,
      auth: false
    },
    component: () => import('@/card/views/template2/login/list')
  },
  {
    path: '/template2/home',
    name: 'template2_index',
    meta: {
      title: '首页',
      header: false,
      bottom: false,
      keepAlive: false,
      auth: false
    },
    component: () => import('@/card/views/template2/home/index')
  }
]



// WEBPACK FOOTER //
// ./src/card/router/template2/index.js